// src/components/result/YouAreBlock.js
import React from "react";

const TRAIT_DESC = {
  E: "사람들과 섞여 있을 때 에너지가 더 잘 차오르는 편",
  I: "혼자만의 시간에서 배터리를 충전하는 편",
  S: "지금 눈앞에 보이는 것과 실제 경험을 더 믿는 편",
  N: "패턴, 밈, 숨은 의미를 찾아내는 걸 좋아하는 편",
  T: "상황을 일단 논리·기준으로 정리해 보려는 편",
  F: "분위기, 감정선, 사람 사이의 공기를 신경 쓰는 편",
  P: "계획보다는 흐름을 타면서 유연하게 움직이는 편",
  J: "할 일·마감·구조를 잡아두면 마음이 편한 편",
};

const TRAIT_ORDER = ["E", "I", "S", "N", "T", "F", "P", "J"];

const TRAIT_SUMMARY_PART = {
  E: "사람 속에서 에너지를 얻고",
  I: "혼자 있을 때 에너지를 채우고",
  S: "눈앞의 현실과 실제 데이터를 중시하고",
  N: "아이디어와 가능성을 좇고",
  T: "논리와 기준으로 판단하고",
  F: "감정과 관계의 결을 신경 쓰고",
  P: "상황에 맞게 유연하게 반응하고",
  J: "계획과 마감을 챙기면서 움직이는",
};

// 상위 성향: 40점 이상 중에서 최대 4개
function pickDominantTraits(scores) {
  const sorted = [...TRAIT_ORDER]
    .map((key) => ({ key, value: scores[key] ?? 0 }))
    .sort((a, b) => b.value - a.value);

  const dominant = sorted.filter((t) => t.value >= 40).slice(0, 4);

  if (dominant.length === 0 && sorted.length > 0) {
    dominant.push(sorted[0]);
  }

  return dominant;
}

// 요약 문장: 상위 3개를 문장으로 풀어주기
function buildSummarySentence(scores) {
  const traits = TRAIT_ORDER.map((key) => ({ key, value: scores[key] ?? 0 }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 3);

  const parts = traits.map((t) => TRAIT_SUMMARY_PART[t.key]).filter(Boolean);

  if (parts.length === 0) {
    return "이걸 종합해보면, 너는 어느 한쪽으로 확 치우치기보다는 상황 따라 모드가 달라지는 사람인 것 같아.";
  }

  let mid = "";
  if (parts.length === 1) {
    mid = parts[0];
  } else if (parts.length === 2) {
    mid = `${parts[0]}, ${parts[1]}`;
  } else {
    mid = `${parts[0]}, ${parts[1]}, 그리고 ${parts[2]}`;
  }

  return `이걸 종합해보면, 너는 ${mid} 있네.`;
}

function YouAreBlock({ scores }) {
  const dominant = pickDominantTraits(scores);

  const titleLabel =
    dominant.map((t) => t.key).join(" · ") || "어느 한쪽으로 치우치지 않은";

  const summarySentence = buildSummarySentence(scores);

  return (
    <section className="result-section">
      <h2 className="result-section-title">
        이제부터 너의 MBTI는{" "}
        <span className="result-section-title-highlight">{titleLabel}</span> 야.
      </h2>
      <br />

      <div className="result-youare-body">
        {dominant.map((t) => (
          <p key={t.key} className="result-body-text result-body-text--em">
            {t.key} ({t.value}점) — {TRAIT_DESC[t.key]}
          </p>
        ))}

        <p className="result-body-text result-body-text--summary">
          <br /> <strong>{summarySentence}</strong>
        </p>
      </div>
    </section>
  );
}

export default YouAreBlock;
